export const TYPING_MESSAGES = [
  'Pensando',
  'Analizando tu solicitud',
  'Entendiendo lo que necesitas',
  'Generando ideas creativas',
  'Creando algo increíble',
  'Trabajando en tu contenido',
  'Preparando tu asset',
  'Casi listo'
];
